import React from 'react'
import Pagination from '@material-ui/lab/Pagination'
import { PaginacaoBox } from './styles'
import Button from '@material-ui/core/Button'
import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'

export default function Paginacao({
    pagina,
    qtdePagina,
    totalPagina,
    setPagina,
    setQtdePagina,
    exportaCsv,
    exportPdf,
    loadingCsv,
    loadingPdf
}) {
    const handlePageChange = (event, value) => {
        setPagina(value)
    }

    const handleQtdePorPaginaChange = (event, value) => {
        setPagina(1)
        setQtdePagina(value.props.value)
    }

    return (
        <PaginacaoBox.Paginas>
            <FormControl style={{ width: "125px", float: "left" }} variant="outlined">
                <InputLabel id="demo-simple-select-outlined-label">Itens por página</InputLabel>
                <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={qtdePagina}
                    onChange={handleQtdePorPaginaChange}
                    label="Itens por página"
                >
                    <MenuItem value="">
                        <em>Escolha uma opção</em>
                    </MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                </Select>
            </FormControl>
            <Pagination count={totalPagina} page={pagina} onChange={handlePageChange} style={{ display: "inline-block", paddingTop: "10px" }} />
            <PaginacaoBox.Exportacao>
                <PaginacaoBox.ExportacaoAcao>
                    <Button size="small" className="bg-alternativo-4 txt-alternativo-3" onClick={exportaCsv}>
                        {
                            loadingCsv
                                ?
                                <CircularProgress
                                    size={22}
                                    style={{
                                        color: '#1a63c1'
                                    }} />
                                : 'CSV'
                        }
                    </Button>
                </PaginacaoBox.ExportacaoAcao>
                <PaginacaoBox.ExportacaoAcao>
                    <Button size="small" className="bg-alternativo-4 txt-alternativo-3" onClick={exportPdf}>
                        {
                            loadingPdf
                                ?
                                <CircularProgress
                                    size={22}
                                    style={{
                                        color: '#1a63c1'
                                    }} />
                                : 'PDF'
                        }
                    </Button>
                </PaginacaoBox.ExportacaoAcao>
            </PaginacaoBox.Exportacao>
        </PaginacaoBox.Paginas>
    )
}